/*
 * @Description: 实时定位驾驶舱 — B1「团队轨迹」本地 mock
 *   为每个在线成员生成最近 ~3 小时的轨迹点（从起点走到其当前位置），
 *   中间故意留一段时间间隔以演示「中断段」（红色虚线）。
 *   所有时间基于 MOCK_NOW_MS，确定性生成（不依赖 Date.now / random）。
 */
import { MOCK_NOW_MS } from '../constants'
import { MOCK_REALTIME_LOCATIONS } from './locations.mock'
import { TeamTrackData, TrackPoint, parseLngLat } from '../types/cockpit.types'

const POINT_COUNT = 36
const STEP_MS = 5 * 60 * 1000 // 相邻点间隔 5 分钟（共约 3 小时）
const GAP_START_INDEX = 15 // 制造中断的起始下标
const GAP_END_INDEX = 19 // 中断结束下标（跳过 [15,19) 这几点）

/** 生成单个成员的轨迹点：从起点线性走到终点（当前位置） */
function generatePoints(endLng: number, endLat: number): TrackPoint[] {
  const startLng = endLng - 0.012
  const startLat = endLat - 0.009
  const points: TrackPoint[] = []

  for (let i = 0; i < POINT_COUNT; i++) {
    // 跳过一段，制造时间间隔 → 中断段
    if (i >= GAP_START_INDEX && i < GAP_END_INDEX) continue

    const ratio = i / (POINT_COUNT - 1)
    const lng = startLng + (endLng - startLng) * ratio
    const lat = startLat + (endLat - startLat) * ratio
    const locateTime = MOCK_NOW_MS - (POINT_COUNT - 1 - i) * STEP_MS

    points.push({
      location: `${lng.toFixed(6)},${lat.toFixed(6)}`,
      locateTime,
      speed: 1.2,
      direction: 90
    })
  }

  return points
}

export const MOCK_TEAM_TRACK: TeamTrackData = {
  members: MOCK_REALTIME_LOCATIONS.items
    .filter((m) => m.online)
    .map((m) => {
      const ll = parseLngLat(m.location)
      return {
        userId: m.userId,
        name: m.name,
        avatar: m.avatar,
        points: ll ? generatePoints(ll.lng, ll.lat) : []
      }
    })
}
